import * as styledComponents from 'styled-components';
import { Theme } from './theme';

const {
  default: styled,
  css,
  createGlobalStyle,
  ThemeProvider,
} = styledComponents as unknown as styledComponents.ThemedStyledComponentsModule<Theme>;

export { css, createGlobalStyle, ThemeProvider };
export default styled;
